module.exports = __webpack_public_path__ + "static/4-insights-2d7030a3aa9c8f98b672d259e025f806.jpg";